export default {
  title: 'Ordredetaljer',
  order_again: 'Bestil igen',
};
